import { useNavigate } from "react-router-dom"

export const navigateWithCmd = (
  path: string,
  isModifierPressed: boolean,
  navigate: ReturnType<typeof useNavigate>,
  basepath?: string,
) => {
  const fullpath = basepath ? basepath + path : path
  if (isModifierPressed) {
    window.open(fullpath, "_blank")
  } else {
    navigate(path)
  }
}
